import { render, staticRenderFns } from "./MyNote.vue?vue&type=template&id=2fee0558&"
import script from "./MyNote.vue?vue&type=script&lang=js&"
export * from "./MyNote.vue?vue&type=script&lang=js&"
import style0 from "./MyNote.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports